import { useEffect, useMemo, useState, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import CommonMessage from "../../common/CommonMessage";


//import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { GetPincodeNotSrvsOrders } from "../../services/orderService";

const modules = [AllCommunityModule];

const PincodeNotsrvs = () => {
    const [allRows, setAllRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [error, setErrors] = useState("");
const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await GetPincodeNotSrvsOrders();
                if (
                    response?.statusCode === 200 &&
                    response?.success === true
                ) {
                    setErrors("");

                    const rows = [];

                    (response.data ?? []).forEach((order) => {

                        // ================= PARENT ROW =================
                        rows.push({
                            id: order.id,
                            firstName: order.firstName,
                            lastName: order.lastName,
                            email: order.email,
                            mobile: order.mobile,

                            address: order.address,
                            address2: order.address2,
                            landMark: order.landMark,
                            state: order.state,
                            city: order.city,
                            postalCode: order.postalCode,

                            paymentName:
                                order.payment?.name || "",

                            diseaseName:
                                order.issueDisease?.name || "",

                            discount: order.discount,
                            shiping: order.shiping,
                            gTotal: order.gTotal,

                            rowId: `parent-${order.id}`,

                            type: "parent",

                            hasChildren:
                                order.getOrderItemDtos?.length > 0,
                        });

                        // ================= CHILD ROW =================
                        order.getOrderItemDtos?.forEach(
                            (item, index) => {
                                rows.push({
                                    id: item.id,

                                    productName:
                                        item.productName,

                                    quantity:
                                        item.quantity,

                                    priceAtPurchase:
                                        item.priceAtPurchase,

                                    rowId: `child-${order.id}-${index}`,

                                    parentId: order.id,

                                    type: "child",
                                });
                            }
                        );
                    });

                    setAllRows(rows);
                } else {
                    setErrors(
                        response?.message ||
                        "Something went wrong"
                    );
                }
            } catch (error) {
                console.log(error);

                setErrors(
                    error.message ||
                    "Something went wrong"
                );
            }finally {
    setLoading(false);
}

        };

        fetchData();
    }, []);

    // Expand / Collapse
    const toggleExpand = useCallback((id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    }, []);

    // Visible Rows
    const rowData = useMemo(() => {
        return allRows.filter((row) => {
            if (row.type === "parent") return true;

            return expandedRows[row.parentId];
        });
    }, [allRows, expandedRows]);

    // Expand Button Renderer
    const ExpandCell = useCallback(
        (props) => {
            const row = props.data;

            if (
                row.type === "child" ||
                !row.hasChildren
            ) {
                return null;
            }

            return (
                <button
                    onClick={(e) =>{
                        e.stopPropagation();
                        toggleExpand(row.id)
                    }}
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                    }}
                >
                    {expandedRows[row.id]
                        ? "−"
                        : "+"}
                </button>
            );
        },
        [expandedRows, toggleExpand]
    );
   
    const columnDefs = useMemo(
        () => [
            
            {
                headerName: "",
                width: 40,
                cellRenderer: ExpandCell,
                sortable: false,
                filter: false,
            },

            {
                field: "id",
                headerName: "ID",
                width: 50,
            },
{
        field: "dateCreated",
        headerName: "Date Created",
      },
            {
                field: "firstName",
                headerName: "Customer Name",
                width: 120,

                valueGetter: (params) => {
                    if (
                        params.data.type ===
                        "parent"
                    ) {
                        return `${params.data.firstName} ${params.data.lastName}`;
                    }

                    return "Order Item";
                },

                cellStyle: (params) => ({
                    paddingLeft:
                        params.data.type ===
                            "child"
                            ? "40px"
                            : "10px",

                    fontWeight:
                        params.data.type ===
                            "parent"
                            ? "bold"
                            : "normal",
                }),
            },

            {
                field: "email",
                headerName: "Email",
                //flex: 1,
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.email
                        : "",
            },

            {
                field: "mobile",
                headerName: "Mobile",
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.mobile
                        : "",
            },

            {
                field: "address",
                headerName: "Address",
                //flex: 1,
                width: 200,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.address
                        : "",
            },
            {
                field: "state",
                headerName: "State",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.state
                        : "",
            },
            {
                field: "city",
                headerName: "City",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.city
                        : "",
            },

            {
                field: "postalCode",
                headerName: "Pincode",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.postalCode
                        : "",
            },

            {
                field: "paymentName",
                headerName: "Payment",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.paymentName
                        : "",
            },

            {
                field: "diseaseName",
                headerName: "Disease",
                width: 170,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.diseaseName
                        : "",
            },

            {
                field: "discount",
                headerName: "Discount",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.discount
                        : "",
            },

            {
                field: "shiping",
                headerName: "Shipping",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.shiping
                        : "",
            },

            {
                field: "gTotal",
                headerName: "Grand Total",
                width: 150,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.gTotal
                        : "",
            },

            // ================= CHILD ROW DATA =================

            {
                field: "productName",
                headerName: "Product",
                width: 180,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.productName
                        : "",
            },

            {
                field: "quantity",
                headerName: "Qty",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.quantity
                        : "",
            },

            {
                field: "priceAtPurchase",
                headerName: "Price",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.priceAtPurchase
                        : "",
            },
        ],
        [ExpandCell]
    );
    return (
        <div className="container-fluid py-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>Pincode List</h4>
            </div>
           
            <div
                className="ag-theme-quartz"
                style={{
                    width: "100%",
                }}
            >
                <AgGridReact
                loading={loading}
                    modules={modules}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={10}
                    rowHeight={45}
                    animateRows={true}
                    domLayout="autoHeight"
                    getRowId={(params) =>
                        params.data.rowId
                    }

                    getRowStyle={(params) => {
                        if (params.data.type === "child") {
                            return {
                                background: "#f8f9fa",
                            };
                        }
                    }}
                />
            </div>

            {error && <CommonMessage text={error} />}
        </div>
    );
};

export default PincodeNotsrvs;